import { render, staticRenderFns } from "./Deliver.vue?vue&type=template&id=63614eb9&scoped=true&"
import script from "./Deliver.vue?vue&type=script&lang=js&"
export * from "./Deliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63614eb9",
  null
  
)

export default component.exports